import React from "react";
import { ArticleTitle } from "@/styles/style";
import moment from "moment";
import { getTime } from "@/utils/utils";

const GuideHeader = ({ title, time }) => {
  return (
    <header>
      <ArticleTitle data-testid={`title`}>{title}</ArticleTitle>
      <p
        style={{
          fontWeight: 600,
          opacity: 0.5,
          marginBottom: `1rem`,
        }}
      >
        <time dateTime={moment.unix(time).toISOString()}>{getTime(time)}</time>
      </p>
    </header>
  );
};

export default GuideHeader;
